<template>
  <div>
    <template v-if="carrier === 'device'">
      <template v-if="$isMobile">
        <i18n-t
          class="q-pt-md"
          keypath="two_factor_verify_code_template.mobile.qr_code_description"
          scope="global"
          style="line-height: 1.6em"
          tag="p"
        >
          <template #tapHere>
            <a
              class="q-px-sm background-white font-weight-500 rounded-borders inline-block text-black"
              :href="uri"
              @click.prevent="openAuthenticator"
            >
              {{
                $t(
                  "two_factor_verify_code_template.mobile.qr_code_description_link_text"
                )
              }}
            </a>
          </template>
        </i18n-t>
        <div
          class="smaller q-mt-sm absolute flex items-center text-white"
          style="top: 100%"
        >
          <span class="q-mr-xs">{{
            $t("two_factor_verify_code_template.uri_label")
          }}</span>
          <button
            class="q-btn bold pointer smaller q-pa-none"
            style="background: transparent"
            @click="copyUri"
          >
            {{ $t("two_factor_verify_code_template.mobile.uri_button") }}
          </button>
        </div>
      </template>
      <template v-else>
        <p>
          {{ $t("two_factor_verify_code_template.qr_code_description") }}
        </p>
        <img
          :alt="$t('global.qr_code')"
          class="q-mx-auto block"
          :src="qrCodeBase64"
        />
        <div class="soft smaller flex items-center justify-center">
          <span class="q-mr-xs">{{
            $t("two_factor_verify_code_template.uri_label")
          }}</span>
          <button
            id="copy2faButton-${uid}"
            class="q-btn pointer smaller underline"
            style="background: transparent"
          >
            {{ $t("two_factor_verify_code_template.uri_button") }}
          </button>
        </div>
        <p>{{ $t("two_factor_verify_code_template.code_label") }}</p>
      </template>
    </template>
    <template v-else>
      <p
        v-if="errorMessage"
        class="q-pa-sm"
        style="background-color: #f3c9ca"
      >
        {{ errorMessage }}
      </p>
      <span>{{ message }}</span>
    </template>

    <div class="column q-mt-sm q-mb-sm">
      <InputText
        v-model="localCode"
        autocapitalize="none"
        autocomplete="off"
        autocorrect="off"
        maxlength="6"
        new-design
      />
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

import InputText from "shared/components/base/InputText.vue";
import useClipboard from "shared/composables/useClipboard";
import { openSystemBrowser } from "shared/helpers/external";

export default {
  name: "TwoFactorVerifyCodeTemplate",
  components: {
    InputText,
  },
  props: {
    uri: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
    carrier: {
      type: String,
      required: true,
    },
    error: {
      type: Error,
      default: null,
    },
  },
  emits: ["update:code"],
  setup() {
    const { copyToClipboard } = useClipboard();

    return { copyToClipboard };
  },
  data() {
    return {
      qrCodeBase64: "",
    };
  },
  computed: {
    localCode: {
      get() {
        return this.code;
      },
      set(value) {
        this.$emit("update:code", value);
      },
    },
    errorMessage() {
      return this.error?.response?.data?.message || this.error?.message || "";
    },
    message() {
      let carrierLabel;

      switch (this.carrier) {
        case "sms":
          carrierLabel = this.$t("global.sms");
          break;
        case "email":
          carrierLabel = this.$t("global.email");
          break;
        default:
          break;
      }

      return this.$t("two_factor_verify_code_template.description", {
        carrierLabel,
      });
    },
  },
  async mounted() {
    if (this.carrier === "device" && this.$isDesktop) {
      this.qrCodeBase64 = await QRCode.toDataURL(this.uri);
    }
  },
  methods: {
    copyUri() {
      this.copyToClipboard(this.uri);
      this.$track("Clicked Copy Two-factor Authentication Code to Clipboard");
    },
    openAuthenticator() {
      openSystemBrowser(this.uri);
    },
  },
};
</script>
